import type { MapRef } from 'react-map-gl';
import { forwardRef } from 'react';
import { Button, IMaybeAsync } from '@sixui/ui';
import stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';

import type { ICommunityMapProps } from '~/components/molecules/CommunityMap';
import type { IContainerProps } from '~/components/utils/Container';
import { CommunityMap } from '~/components/molecules/CommunityMap';
import { IApiCrowdGeoSearchRequestBody } from '~/lib/api/modules/Crowd';
import { useGeoSearchCrowdQuery } from '~/lib/api/modules/Crowd/hooks/useGeoSearchCrowdQuery';

export type ISearchCommunityMapProps = IContainerProps &
  ICommunityMapProps & {
    filter?: IApiCrowdGeoSearchRequestBody;
    onSearchWithin?: () => IMaybeAsync<void>;
  };

const styles = stylex.create({
  searchNearButton: {
    position: 'absolute',
    bottom: 10,
    left: '50%',
    transform: 'translateX(-50%)',
  },
});

export const SearchCommunityMap = forwardRef<MapRef, ISearchCommunityMapProps>(
  function SearchCommunityMap(props, forwardedRef) {
    const { appId, filter, onSearchWithin, ...other } = props;
    const { t } = useTranslation();
    const geoSearchCrowdQuery = useGeoSearchCrowdQuery(
      filter
        ? {
            appId,
            body: filter,
          }
        : undefined,
    );

    return (
      <CommunityMap
        appId={appId}
        data={geoSearchCrowdQuery.data}
        filter={filter}
        ref={forwardedRef}
        {...other}
      >
        <Button
          variant="elevated"
          sx={styles.searchNearButton}
          onClick={onSearchWithin}
          loading={geoSearchCrowdQuery.isFetching}
        >
          {t('SearchCommunityMap.searchNear')}
        </Button>
      </CommunityMap>
    );
  },
);
